import React from 'react';
import { Drawer, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Categories from './Categories';

function Filter({ open, onClose, categories, selectedCategories, setSelectedCategories, categoryColorMap, showClose = true, graphHeight = null, logUserAction, logActionLocation }) {
    const theme = useTheme();

    return ( showClose ? (
        <Drawer
            anchor='bottom'
            open={open}
            onClose={onClose}
            PaperProps={{sx: { borderTopLeftRadius: 20, borderTopRightRadius: 20, maxHeight: '80%' } }}
        >
            <Categories
                onClose={onClose} 
                categories={categories} 
                selectedCategories={selectedCategories} 
                setSelectedCategories={setSelectedCategories} 
                categoryColorMap={categoryColorMap} 
                showClose={showClose}
                logUserAction={logUserAction}
                logActionLocation={logActionLocation}
            />
        </Drawer>
    ) : (
        <Stack
            minWidth={'33%'}
            maxWidth={'33%'}
            sx={{
                backgroundColor: theme.palette.background.white,
                borderRadius: 1,
                boxShadow: 2,
                // constrain to graphHeight when available so sidebar doesn't exceed graph height
                height: graphHeight ? `${graphHeight}px` : 'auto',
            }}
        >
            <Categories 
                onClose={onClose} 
                categories={categories} 
                selectedCategories={selectedCategories} 
                setSelectedCategories={setSelectedCategories} 
                categoryColorMap={categoryColorMap}
                showClose={showClose} 
                logUserAction={logUserAction}
                logActionLocation={logActionLocation}
            />
        </Stack>
    ));
}

export default Filter;